<div class="relative">
  <!-- User menu button -->
  <button
    type="button"
    class="flex items-center space-x-3 p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-500"
    (click)="toggle()"
  >
    <!-- Avatar -->
    @if (effectiveUser()?.photoUrl) {
      <img
        [src]="effectiveUser()?.photoUrl"
        [alt]="getUserDisplayName()"
        class="w-8 h-8 rounded-full object-cover"
      />
    } @else {
      <div
        class="w-8 h-8 rounded-full bg-primary-600 flex items-center justify-center text-white text-sm font-medium"
      >
        {{ getUserInitials() }}
      </div>
    }

    <!-- Name (hidden on mobile) -->
    <span class="hidden md:inline text-sm text-gray-700 dark:text-gray-300">
      {{ getUserDisplayName() }}
    </span>

    <!-- Dropdown arrow -->
    <svg
      class="w-4 h-4 text-gray-500 dark:text-gray-400 transition-transform"
      [class.rotate-180]="isOpen()"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <!-- Dropdown menu -->
  @if (isOpen()) {
    <!-- Backdrop to close menu -->
    <div
      class="fixed inset-0 z-40"
      role="button"
      tabindex="0"
      aria-label="Close menu"
      (click)="close()"
      (keydown.enter)="close()"
      (keydown.escape)="close()"
    ></div>

    <div
      class="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-800 rounded-md shadow-lg border border-gray-200 dark:border-gray-700 z-50"
    >
      <!-- User info -->
      <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
        <p class="text-sm font-medium text-gray-900 dark:text-white">
          {{ getUserDisplayName() }}
        </p>
        <p class="text-sm text-gray-500 dark:text-gray-400 truncate">
          {{ getUserEmail() }}
        </p>
      </div>

      <!-- Logout -->
      <div class="border-t border-gray-200 dark:border-gray-700 py-1">
        <a
          routerLink="/auth/logout"
          class="flex items-center px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700"
          (click)="close()"
        >
          <svg class="w-4 h-4 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
          Sign Out
        </a>
      </div>
    </div>
  }
</div>
